import React from "react";
import { Briefcase } from "lucide-react";
import PolicyShell from "../components/PolicyShell";

/**
 * Conflict of Interest Policy — required for UK CIO trustees to demonstrate
 * good-governance. Plain-English summary that the volunteer governance
 * committee can update as the organisation grows.
 */
const SECTIONS = [
  {
    title: "Purpose",
    items: [
      "To protect the integrity of ABGN-UK and ensure decisions are made in the best interests of the community, not in the personal interest of any trustee, member or volunteer.",
      "To safeguard donor and member trust by being transparent about any actual, potential or perceived conflict.",
    ],
  },
  {
    title: "What is a conflict of interest?",
    items: [
      "A trustee, employee or close family member stands to gain financially or materially from a decision being made.",
      "A trustee holds another role (paid or unpaid) where their loyalty might be divided between two organisations.",
      "A trustee has a personal, political, religious or social relationship with someone who would be materially affected by a decision.",
      "An external party seeks to influence ABGN-UK by gifts, hospitality or other benefits.",
    ],
  },
  {
    title: "Declaration procedure",
    items: [
      "Each trustee completes a register of interests on appointment, updated annually and whenever a new interest arises.",
      "At the start of every trustee meeting, the chair invites declarations of conflict relating to any item on the agenda.",
      "Declared conflicts are recorded in the minutes. The conflicted trustee withdraws from the relevant discussion and does not vote on it.",
      "Where the entire committee is conflicted (rare), the decision is deferred until independent advice is sought.",
    ],
  },
  {
    title: "Gifts & hospitality",
    items: [
      "Volunteers and trustees do not solicit gifts. Modest gifts of dāna (under £25 in value) may be accepted on behalf of ABGN-UK.",
      "Any gift over £25, or any pattern of recurring small gifts from a single source, is logged in the gifts register and reported to the chair.",
      "Hospitality (meals, travel, accommodation) offered by external parties is declined unless approved by the chair on a case-by-case basis.",
    ],
  },
  {
    title: "Breach",
    items: [
      "A failure to declare a known conflict is a serious matter and may result in the trustee being asked to step down.",
      "Any member, volunteer or trustee may raise concerns confidentially with the chair (or, if the chair is involved, with the secretary) at info@ambedkaritebuddhistglobalnetworkuk.com.",
      "Good-faith whistleblowing is protected; we do not retaliate against reporters.",
    ],
  },
];

export default function ConflictOfInterest() {
  return <PolicyShell icon={Briefcase} eyebrow="Policy" title="Conflict of interest policy"
    intro="ABGN-UK trustees, volunteers and members declare any interest that might influence, or be seen to influence, decisions made on behalf of the Sangha."
    sections={SECTIONS}
    approvedNote="Approved February 2026 · Reviewed annually by the volunteer governance committee."
  />;
}
